
namespace RioERP.Carts {
    export class CartProductSpecificationsColumns {
        static columnsKey = 'Carts.CartProductSpecifications';
    }
}